export enum RoomType {
    GROUP,
    DIRECT,
    BUSINESS,
}
